<template>
  <el-table :data="rows" :max-height="maxHeight">
    <el-table-column label="序号" prop="index" width="80" />
    <el-table-column label="规则类型" prop="ruleTypeText" width="140">
      <template slot-scope="{ row }">
        <el-tag
          :color="row.ruleTypeColor.background"
          :style="{
            color: row.ruleTypeColor.color,
            borderColor: row.ruleTypeColor.background,
            fontWeight: 600,
          }"
          >{{ row.ruleTypeText }}</el-tag
        >
      </template>
    </el-table-column>
    <el-table-column label="命中规则" prop="hitRule" min-width="220">
      <template slot-scope="{ row }">
        <div class="hit-rule-text" :class="{ 'is-truncated': truncateRule }">{{ row.hitRule }}</div>
      </template>
    </el-table-column>
    <el-table-column label="命中首付比" prop="hitPrepayRate" width="140">
      <template slot-scope="{ row }">
        <span :class="{ 'danger-cell': row.isEffective === true }">{{
          row.hitPrepayRate
        }}</span>
      </template>
    </el-table-column>
    <el-table-column label="命中建议" prop="hitSuggest" min-width="200">
      <template slot-scope="{ row }">
        <span :class="{ 'danger-cell': row.isEffective === true }">{{
          row.hitSuggest
        }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "HitRuleTable",
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [String, Number],
      default: undefined,
    },
    truncateRule: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.hit-rule-text {
  white-space: pre-line;
  overflow-wrap: anywhere;

  &.is-truncated {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.danger-cell {
  color: red;
}
</style>
